import React from 'react'
import { TextSM } from '../../../../Components/Text/NormalText';
import NuDate from '../../../../Components/Utils/NuDate';
import { Link, useParams } from 'react-router-dom';
import { NewPill } from '../../../../Components/Utils/StatusPills';
import ViewMore from './ViewMore';

function ContractorsCard({ item,getData }) {
   
    return (
        <div className="w-full border bg-white rounded-lg shadow-xl mt-1.5 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-8 h-5 bg-slate-300  flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.supplierId || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.vendorStatus &&
               
                  <NewPill text={item?.vendorStatus} />
              
                }
            </div>
            <ViewMore id={item?.supplierId}         getData={getData}
  data={item} />
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/contacts/main-contractors/view/${item?.supplierId}`}
              state={{ data: item }}
            >
              {item?.refNumber || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
             <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"Company : " || "-"} />
                            <div className=" text-xs ">{item?.companyName || "-"}</div>
                          </div>
                        </div>
                        <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"Type : " || "-"} />
                            <div className=" text-xs ">{item?.vendorType || "-"}</div>
                          </div>
                        </div>
                        <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"Phone : " || "-"} />
                            <div className=" text-xs ">{item?.phone || "-"}</div>
                          </div>
                        </div>
                      
                        {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"City : " || "-"} />
                            <div className=" text-xs ">{item?.city || "-"}</div>
                          </div>
                        </div> */}
                       
                        
                        
                        <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"CreatedByName: " || "-"} />
                            <div className=" text-xs ">{item?.createdByName || "-"}</div>
                          </div>
                        </div>
            
                        <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"Website : " || "-"} />
                            <div className=" text-xs ">{item?.website || "-"}</div>
                          </div>
                        </div>
            
  
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"InspectionDate : " || "-"} />
                <div className=" text-xs ">
                  {(item?.inspectionDate != "None" && (
                    <NuDate value={item?.inspectionDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
  
           
          </div>
        </div>
      </div>
    );
  }

export default ContractorsCard
